export default "__VITE_ASSET__gyfW2fWB__"